import { GETSINGLEINVOICEDETAILES_SUCCESS, GETSINGLEINVOICEDETAILES_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getSingleInvoiceDetaileReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETSINGLEINVOICEDETAILES_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETSINGLEINVOICEDETAILES_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getSingleInvoiceDetaileReducer;
